<footer class="site-footer">

  <div class="footer-main">

    <!-- Brand column -->
    <div class="footer-col footer-brand">
      <img src="assets/logo.png" alt="Already Done" class="footer-logo">
      <p class="footer-tagline">Connecting homeowners with trusted trade professionals across New England.</p>
      <div class="footer-contact">
        <a href="mailto:support@alreadydone.us" class="footer-contact-link">
          <mat-icon>email</mat-icon> support@alreadydone.us
        </a>
        <a href="tel:+15085550100" class="footer-contact-link">
          <mat-icon>phone</mat-icon> (508) 555-0100
        </a>
        <div class="footer-location">
          <mat-icon>location_on</mat-icon> Middleboro, MA
        </div>
      </div>
    </div>

    <!-- Services column -->
    <div class="footer-col">
      <h4 class="footer-heading">Services</h4>
      <ul class="footer-links">
        <li><a routerLink="/browse-services" class="footer-link">Browse Services</a></li>
        <li><a routerLink="/projects" class="footer-link">Project Management</a></li>
        <li><a routerLink="/get-a-bid" class="footer-link">Get a Bid</a></li>
        <li><a routerLink="/become-provider" class="footer-link">Become a Provider</a></li>
      </ul>
    </div>

    <!-- Company column -->
    <div class="footer-col">
      <h4 class="footer-heading">Company</h4>
      <ul class="footer-links">
        <li><a routerLink="/contactus" class="footer-link">Contact Us</a></li>
        <li><a routerLink="/privacy" class="footer-link">Privacy Policy</a></li>
        <li><a routerLink="/auth" class="footer-link">Sign In</a></li>
      </ul>
    </div>

    <!-- Payment / trust column -->
    <div class="footer-col footer-trust">
      <h4 class="footer-heading">Secure Payments</h4>
      <img src="./assets/images/CreditCards.png" alt="Accepted payment methods" class="footer-cards">
      <div class="footer-badges">
        <span class="trust-badge">
          <mat-icon>verified_user</mat-icon> Licensed &amp; Insured
        </span>
        <span class="trust-badge">
          <mat-icon>thumb_up</mat-icon> Satisfaction Guaranteed
        </span>
        <img src="./assets/images/american-flag-th.png" width="32" alt="American-made" class="footer-flag">
      </div>
    </div>

  </div>

  <div class="footer-bottom">
    <span>© {{ currentYear }} Already Done. All rights reserved.</span>
    <span class="footer-divider">·</span>
    <a routerLink="/privacy" class="footer-bottom-link">Privacy Policy</a>
    <span class="footer-divider">·</span>
    <a routerLink="/contactus" class="footer-bottom-link">Contact</a>
  </div>

</footer>
